import { Engine } from '../Engine'
import './info.scss'

export type InfoConfig = {
  description?: string
  title?: string
}

export class InfoUI {
  constructor(private engine: Engine, config: InfoConfig = {
    description: '浙江博鉴提供技术支持',
    title: '数字化运维'
  }) {
    const container = document.createElement('div')
    container.classList.add('info-container')
    container.insertAdjacentHTML(
      'beforeend',
      `
${config.title ? `<h5>${config.title}</h5>` : ''}
${config.description
        ? `<div class="description">
  <span>${config.description}</span>
 </div>`
        : ``
      }
    `
    )
    this.engine.canvas.parentElement?.prepend(container)
  }
}
